import React, {
    useCallback, useContext, useState, useEffect
} from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { FaUserMd, FaLock } from 'react-icons/fa'
import { Link, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import ReactTooltip from 'react-tooltip'
import { v4 as uuid } from 'uuid'

import { api } from '~/services/api'
import history from '~/services/history'

import { criptografar } from '~/util/crypto'
import scroll from '~/util/scroll'

import { GlobalContext } from '~/contexts/GlobalContext'

import { Textbox, Button, List } from '~/components/Form'

import { Container, Content, LoginsContainer } from './styles'

import logo from '~/assets/images/logo-mini.png'

import useQuery from '~/hooks/useQuery'

const validation = Yup.object({
    crm: Yup.string().required('CRM obrigatório.'),
    senha: Yup.string().required('Senha obrigatória.')
})

const baseInitialValues = {
    crm: '',
    senha: ''
}

export default function SignIn() {
    scroll.toTop()

    const { setUser, setSessionId } = useContext(GlobalContext)

    const [initialValues, setInitialValues] = useState(baseInitialValues)
    const [login, setLogin] = useState({
        crm: '',
        senha: ''
    })
    const [crm, setCrm] = useState('')

    const {
        atendimento, processo, enquete, atendimento_abrir
    } = useQuery()
    const location = useLocation()

    const abertura_atendimento = location?.state?.abertura_atendimento

    const handleSubmit = useCallback(async (values, { setSubmitting }) => {
        try {
            const body = {
                ...values,
                crm: values.crm || 0
            }
            console.log(values.crm)
            const session = await api.post('sessao', body)

            if (session.usuario.associado?.status_associacao.id === 6) {
                session.usuario.perfil.grupos = session.usuario.perfil.grupos.filter(g => [2, 24].includes(g.id))
            }

            setUser(session.usuario)
            setSessionId(uuid())

            const ciphed = criptografar(JSON.stringify(session.usuario))

            sessionStorage.setItem(process.env.REACT_APP_SESSION_STORAGE_TOKEN, session.token)
            sessionStorage.setItem(process.env.REACT_APP_SESSION_STORAGE_USER, ciphed)

            setSubmitting(false)

            if (atendimento) {
                history.push(`/atendimento/${atendimento}`)
            } else if (processo) {
                history.push(`/processos/${processo}`)
            } else if (enquete) {
                history.push(`/enquete/${enquete}/votar`)
            } else if (abertura_atendimento) {
                history.push({
                    pathname: '/processos',
                    state: {
                        abertura: true
                    }
                })
            } else if (atendimento_abrir) {
                history.push('/processos?abertura=1')
            } else {
                history.push('/dashboard')
            }
        } catch (e) {
            console.log(e)
            toast.error(e.msg || e)
        }
    }, [])

    useEffect(() => {
        setInitialValues(login)
        setCrm(login.crm)
    }, [login])

    useEffect(() => {
        const storedLogin = JSON.parse(localStorage.getItem('gestaonamao_admin'))

        if (storedLogin) {
            setLogin({
                ...storedLogin,
                hasStoredLogin: true
            })
        }
    }, [])

    return (
        <>
            <Container>
                <div className="space" style={{ width: '100%' }} />

                <Content className="animated fadeInUp faster delay-300ms">
                    <img src={logo} alt="SINDMEPA" />

                    <Formik
                        initialValues={initialValues}
                        validationSchema={validation}
                        onSubmit={handleSubmit}
                        enableReinitialize
                    >
                        {({ isSubmitting }) => (
                            <Form>
                                <h1>Login</h1>

                                <Textbox
                                    name="crm"
                                    label="CRM ou código de acadêmico"
                                    onChange={e => {
                                        setCrm(e.target.value)
                                        setLogin({
                                            crm: e.target.value,
                                            senha: login.senha
                                        })
                                    }}
                                    value={crm}
                                    icon={{ source: FaUserMd, size: 18 }}
                                />

                                <Textbox name="senha" type="password" label="Senha" autocomplete="on" icon={{ source: FaLock, size: 16 }} disableSubmitWithEnter={false} />

                                <Button type="submit" loading={isSubmitting} className="transparent">Entrar</Button>

                                <p>ou</p>

                                <Link to="/pass_recover">Esqueci a senha</Link>

                                <Link to="/matricula_recover">Esqueci meu código (acadêmico)</Link>
                            </Form>
                        )}
                    </Formik>
                </Content>

                {process.env.REACT_APP_ENVIRONMENT !== 'production' && (
                    <LoginsContainer className="animated fadeInRight faster delay-500ms">
                        <h1>Logins predefinidos</h1>

                        <p>{`Ambiente: ${process.env.REACT_APP_ENVIRONMENT}`}</p>

                        <List
                            options={[
                                { label: 'Admin', value: 'admin' },
                                // { label: 'Waldir Cardoso (diretor)', value: 'waldir' },
                                { label: 'Paulo Bronze (diretor)', value: 'diretor' },
                                { label: 'Emanuel Resque (diretor)', value: 'emanuel' },
                                { label: 'Andre Varela (diretor)', value: 'andre' },
                                { label: 'Ana Cláudia (médica)', value: 'medico' },
                                { label: 'Rita Lobato (plano de saúde)', value: 'plano_saude' },
                                { label: 'Marcos Nunes (financeiro)', value: 'financeiro' },
                                { label: 'Josi Dória (secretaria)', value: 'secretaria' },
                                { label: 'Augusto Lopes (advogado super)', value: 'advogado_super' },
                                { label: 'Roberto Santos (advogado)', value: 'advogado' },
                                { label: 'Glayce Albuquerque (recepção)', value: 'recepcao' },
                                { label: 'Marta Brasil (imprensa)', value: 'imprensa' },
                                { label: 'Jailson Souza (prest. de serviço)', value: 'fornecedor' },
                                { label: 'Daniel Miranda (acadêmico)', value: 'academico' },
                                // { label: 'Belmiro Vinente (núcleo acadêmico)', value: 'nucleo_academico' },
                                // { label: 'Alessandra Campos (acadêmico super)', value: 'academico_super' },
                                { label: 'Maricleusa Santos (demandante externo)', value: 'demandante_externo' }
                            ]}
                            onChange={e => {
                                switch (e.value) {
                                    case 'admin':
                                        setLogin({
                                            crm: 1,
                                            senha: '123456'
                                        })
                                        break
                                    case 'emanuel':
                                        setLogin({
                                            crm: 2174,
                                            senha: '123456'
                                        })
                                        break
                                    case 'andre':
                                        setLogin({
                                            crm: 10105,
                                            senha: '123456'
                                        })
                                        break
                                    case 'diretor':
                                        setLogin({
                                            crm: 6271,
                                            senha: 123456
                                        })
                                        break
                                    case 'medico':
                                        setLogin({
                                            crm: 10610,
                                            senha: 123456
                                        })
                                        break
                                    case 'plano_saude':
                                        setLogin({
                                            crm: 8000005,
                                            senha: 123456
                                        })
                                        break
                                    case 'secretaria':
                                        setLogin({
                                            crm: 8000007,
                                            senha: 123456
                                        })
                                        break
                                    case 'advogado_super':
                                        setLogin({
                                            crm: '37979795253',
                                            senha: 37979795253
                                        })
                                        break
                                    case 'advogado':
                                        setLogin({
                                            crm: '95121271050',
                                            senha: 95121271050
                                        })
                                        break
                                    case 'imprensa':
                                        setLogin({
                                            crm: '8000011',
                                            senha: 123456
                                        })
                                        break
                                    case 'advogado2':
                                        setLogin({
                                            crm: '06748996287',
                                            senha: 123456
                                        })
                                        break
                                    case 'academico':
                                        setLogin({
                                            crm: 9000451,
                                            senha: 123456
                                        })
                                        break
                                    case 'nucleo_academico':
                                        setLogin({
                                            crm: 9000064,
                                            senha: 123456
                                        })
                                        break
                                    case 'academico_super':
                                        setLogin({
                                            crm: 9000010,
                                            senha: 123456
                                        })
                                        break
                                    case 'recepcao':
                                        setLogin({
                                            crm: 8000002,
                                            senha: '123456'
                                        })
                                        break
                                    case 'financeiro':
                                        setLogin({
                                            crm: 8000008,
                                            senha: '123456'
                                        })
                                        break
                                    case 'demandante_externo':
                                        setLogin({
                                            crm: '21212211222',
                                            senha: '21212211222'
                                        })
                                        break
                                    case 'fornecedor':
                                        setLogin({
                                            crm: '43756304000196',
                                            senha: '123456'
                                        })
                                        break
                                    default: break
                                }
                            }}
                        />
                    </LoginsContainer>
                )}
            </Container>

            <ReactTooltip
                place="top"
                effect="solid"
                type="dark"
            />
        </>
    )
}
